"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MiddleSectionFilterField = exports.ReviewAttributeField = exports.TableDynamicColumnsField = exports.TableSortField = exports.TableColumnFilterField = exports.TableFilterItemField = exports.TableFilterField = exports.ViewQueryStateField = exports.VIEW_QUERY_STATE_QUERY_KEY = exports.VIEW_QUERY_STATE_VERSION = void 0;
exports.VIEW_QUERY_STATE_VERSION = 1;
exports.VIEW_QUERY_STATE_QUERY_KEY = 'viewState';
var ViewQueryStateField;
(function (ViewQueryStateField) {
    ViewQueryStateField["Version"] = "version";
    ViewQueryStateField["ProjectId"] = "projectId";
    ViewQueryStateField["CatalogId"] = "catalogId";
    ViewQueryStateField["Filter"] = "filter";
    ViewQueryStateField["Search"] = "search";
    ViewQueryStateField["Sort"] = "sort";
    ViewQueryStateField["PageSize"] = "pageSize";
    ViewQueryStateField["DynamicColumns"] = "dynamicColumns";
    ViewQueryStateField["MiddleSectionFilter"] = "middleSectionFilter";
    ViewQueryStateField["SelectedTreeNodePath"] = "selectedTreeNodePath";
})(ViewQueryStateField || (exports.ViewQueryStateField = ViewQueryStateField = {}));
var TableFilterField;
(function (TableFilterField) {
    TableFilterField["Items"] = "items";
    TableFilterField["LogicOperator"] = "logicOperator";
})(TableFilterField || (exports.TableFilterField = TableFilterField = {}));
var TableFilterItemField;
(function (TableFilterItemField) {
    TableFilterItemField["Field"] = "field";
    TableFilterItemField["Filter"] = "filter";
})(TableFilterItemField || (exports.TableFilterItemField = TableFilterItemField = {}));
var TableColumnFilterField;
(function (TableColumnFilterField) {
    TableColumnFilterField["Type"] = "type";
    TableColumnFilterField["Search"] = "search";
    TableColumnFilterField["Match"] = "match";
    TableColumnFilterField["Operator"] = "operator";
    TableColumnFilterField["Label"] = "label";
    TableColumnFilterField["List"] = "list";
    TableColumnFilterField["ExcludedValues"] = "excludedValues";
    TableColumnFilterField["SelectAll"] = "selectAll";
    TableColumnFilterField["StartAt"] = "startAt";
    TableColumnFilterField["EndAt"] = "endAt";
    TableColumnFilterField["Low"] = "low";
    TableColumnFilterField["High"] = "high";
})(TableColumnFilterField || (exports.TableColumnFilterField = TableColumnFilterField = {}));
var TableSortField;
(function (TableSortField) {
    TableSortField["Key"] = "key";
    TableSortField["Direction"] = "direction";
    TableSortField["Default"] = "default";
    TableSortField["IsAIEnriched"] = "isAIEnriched";
})(TableSortField || (exports.TableSortField = TableSortField = {}));
var TableDynamicColumnsField;
(function (TableDynamicColumnsField) {
    TableDynamicColumnsField["PinnedColumns"] = "pinnedColumns";
    TableDynamicColumnsField["ColumnsOrder"] = "columnsOrder";
    TableDynamicColumnsField["ExcludedColumns"] = "excludedColumns";
    TableDynamicColumnsField["FilterOptions"] = "filterOptions";
    TableDynamicColumnsField["SelectAllMode"] = "selectAllMode";
    TableDynamicColumnsField["ReviewAttribute"] = "reviewAttribute";
})(TableDynamicColumnsField || (exports.TableDynamicColumnsField = TableDynamicColumnsField = {}));
var ReviewAttributeField;
(function (ReviewAttributeField) {
    ReviewAttributeField["Id"] = "id";
    ReviewAttributeField["PreviousIndex"] = "previousIndex";
})(ReviewAttributeField || (exports.ReviewAttributeField = ReviewAttributeField = {}));
var MiddleSectionFilterField;
(function (MiddleSectionFilterField) {
    MiddleSectionFilterField["Label"] = "label";
    MiddleSectionFilterField["Value"] = "value";
    MiddleSectionFilterField["Unit"] = "unit";
})(MiddleSectionFilterField || (exports.MiddleSectionFilterField = MiddleSectionFilterField = {}));
